import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { useContext, useCallback } from 'sb-hooks'

import { AccordionItemContext } from './AccordionItem'


const AccordionButton = forwardRef((props, ref) => {
  const { onClick, onKeyDown, ...rest } = props

  const { state, setState } = useContext(AccordionItemContext)

  const handleClick = useCallback((event) => {
    if (typeof onClick === 'function') {
      onClick(event)
    }

    if (state.isOpen) {
      setState({ isOpen: false })
    }
    else {
      setState({ isOpen: true })
    }
  }, [ onClick, setState, state.isOpen ])

  const handleKeyDown = useCallback((event) => {
    if (typeof onKeyDown === 'function') {
      onKeyDown(event)
    }

    if (event.key === 'Space' || event.key === 'Enter') {
      event.preventDefault() // prevent scroll
      setState({ isOpen: true })
    }
  }, [ onKeyDown, setState ])

  return (
    <button
      id={state.buttonId}
      aria-controls={state.panelId}
      aria-expanded={state.isOpen}
      type="button"
      ref={ref}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      {...rest}
    />
  )
})

AccordionButton.propTypes = {
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
}


export default AccordionButton
